import type { CalloutBlock } from '../types/report'
import { renderMarkdown } from './markdown'
import styles from './blocks.module.css'

const VARIANT_CLASS = {
  info: styles.calloutInfo,
  success: styles.calloutSuccess,
  warning: styles.calloutWarning,
}

export function Callout({ block }: { block: CalloutBlock }) {
  const variant = block.variant ?? 'info'
  return (
    <div className={[styles.callout, VARIANT_CLASS[variant]].filter(Boolean).join(' ')}>
      {block.title || block.priority ? (
        <div className={styles.calloutHead}>
          {block.title ? <span className={styles.calloutTitle}>{block.title}</span> : null}
          {block.priority ? <span className={styles.calloutPriority}>{block.priority}</span> : null}
        </div>
      ) : null}
      <div className={styles.calloutBody}>{renderMarkdown(block.text)}</div>
    </div>
  )
}
